<form [formGroup]="parkerTagForm">
  <div class="form-row row" [hidden]="parkerTagForm.controls.identificationCode.value || parkerTagForm.controls.barcode.value || parkerTagForm.controls.controlPlateNumber.value">
    <div class="form-group col-12">
      <ejs-message id="msg_warning" content="{{'i18n.validation.tagKeyInfo' | translate}}" severity="Warning"></ejs-message>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="identificationCode"
             class="control-label">{{'i18n.domain.parker-administration.form.identificationCode' | translate}}</label>
      <div class="input-group">
        <input id="identificationCode"
               type="text"
               class="form-control"
               formControlName="identificationCode"/>
        <button class="btn btn-icon btn-outline-secondary e-icons icon-rss" (click)="openCardReaderDialog()"></button>
      </div>
      <app-error-messages [control]="parkerTagForm.controls.identificationCode"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="clientIdent"
             class="control-label">{{'i18n.domain.parker-administration.form.clientIdent' | translate}}</label>
      <input id="clientIdent"
             type="text"
             class="form-control"
             formControlName="clientIdent"/>
      <app-error-messages [control]="parkerTagForm.controls.clientIdent"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="tagType"
             class="control-label">{{'i18n.domain.parker-administration.form.tagType' | translate}}</label>
      <input id="tagType"
             type="text"
             class="form-control"
             formControlName="tagType"/>
      <app-error-messages [control]="parkerTagForm.controls.tagType"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="barcode"
             class="control-label">{{'i18n.domain.parker-administration.form.barcode' | translate}}</label>
      <div class="input-group">
        <input id="barcode"
               type="text"
               class="form-control"
               formControlName="barcode"/>
        <button class="btn btn-icon btn-outline-secondary e-icons icon-qr-code"
                (click)="openQrReaderDialog()"></button>
      </div>
      <app-error-messages [control]="parkerTagForm.controls.barcode"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="countryCode" class="control-label required">{{'i18n.domain.parker-administration.form.countryCode' | translate}}</label>
      <ejs-dropdownlist [dataSource]="countryList"
                        [fields]="enumDropdownSettings"
                        [showClearButton]="true"
                        [allowFiltering]="true"
                        id="countryCode"
                        formControlName="countryCode">
      </ejs-dropdownlist>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="controlPlateType"
             class="control-label">{{'i18n.domain.parker-administration.form.controlPlateType' | translate}}</label>
      <app-enum-drop-down-list formControlName="controlPlateType"
                               id="controlPlateType"
                               width="100%"
                               [enumType]="ControlPlateType"
                               [showClearButton]="false"
                               baseTranslationString="i18n.shared.controlPlateType."></app-enum-drop-down-list>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="controlPlateNumber"
             class="control-label">{{'i18n.domain.parker-administration.form.controlPlateNumber' | translate}}</label>
      <input id="controlPlateNumber"
             type="text"
             class="form-control"
             formControlName="controlPlateNumber"/>
      <app-error-messages [control]="parkerTagForm.controls.controlPlateNumber"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="description"
             class="control-label">{{'i18n.domain.parker-administration.form.description' | translate}}</label>
      <input id="description"
             type="text"
             class="form-control"
             formControlName="description"/>
      <app-error-messages [control]="parkerTagForm.controls.description"></app-error-messages>
    </div>
  </div>
  @if(!isAdd) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label for="enableAutomaticPlateRecognitionParking"
              class="d-block">{{'i18n.domain.parker-administration.form.enableAutomaticPlateRecognitionParking' | translate}}</label>
        <app-yes-no-group-button id="enableAutomaticPlateRecognitionParking"
                                formControlName="enableAutomaticPlateRecognitionParking"></app-yes-no-group-button>
        @if(parkerTagForm.controls.enableAutomaticPlateRecognitionParking.value && parkerTagForm.controls.enableAutomaticPlateRecognitionParking.enabled) {
          <div class="alert alert-warning mt-2">
            {{'i18n.domain.parker-administration.form.enableAutomaticPlateRecognitionParking-enable-info' | translate}}
          </div>
        }
      </div>
    </div>
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label for="active2"
              class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
        <app-yes-no-group-button id="active2"
                                formControlName="active"></app-yes-no-group-button>
      </div>
    </div>
  }
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="defect"
             class="d-block">{{'i18n.domain.parker-administration.form.defect' | translate}}</label>
      <app-yes-no-group-button id="defect"
                               formControlName="defect"></app-yes-no-group-button>
    </div>
    @if(!isAdd) {
      <div class="form-group col-md-12">
        <label for="clientIdent"
              class="control-label">{{'i18n.domain.parker-administration.detail.modified-by' | translate}}</label>
        <input id="modified-by"
              type="text"
              class="form-control"
              formControlName="modifiedBy"/>
      </div>
      <div class="form-group col-md-12">
        <label for="clientIdent"
              class="control-label">{{'i18n.domain.parker-administration.detail.modified-on' | translate}}</label>
        <input id="modified-on"
              type="text"
              class="form-control"
              formControlName="modifiedOn"/>
      </div>
    }
  </div>
</form>

<ejs-dialog #cardReaderDialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.parker-administration.form.dialog.card-reader-title' | translate}}
  </ng-template>
  <ng-template #content>
    <div [formGroup]="cardReaderForm">
      <label for="idCode"
             class="control-label required">{{'i18n.domain.parker-administration.form.identificationCode' | translate}}</label>
      <input #idCode
             id="idCode"
             type="text"
             class="form-control"
             formControlName="identificationCode"/>
      <app-error-messages [control]="cardReaderForm.controls.identificationCode"></app-error-messages>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary" (click)="closeCardDialog()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary ms-2" (click)="saveIdCode()" [disabled]="!cardReaderForm.valid">
      {{'i18n.shared.save' | translate}}
    </button>
  </ng-template>
</ejs-dialog>

<ejs-dialog #qrReaderDialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.parker-administration.form.dialog.qr-reader-title' | translate}}
  </ng-template>
  <ng-template #content>
    @if(showQrText) {
      <div class="mb-3">
        {{'i18n.domain.parker-administration.form.dialog.qr-reader-instruction' | translate}}
      </div>
    }
    @if(qrReaderDialog.visible) {
      <app-qr-scanner [tagType]="TagType.Parker"
                      [clientIdent]="clientIdent"
                      (dataScanned)="onQrScanned($event)"
                      (cameraError)="showQrText = false"
                      (cameraStarted)="showQrText = true">
      </app-qr-scanner>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary" (click)="closeQrDialog()">
      {{'i18n.shared.cancel' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
